
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { VuetifyMixin, BAIconsMixin } from '@/mixins';
import { SportName } from '@/../types/enums';
import FileUploadArea from '../forms/FileUploadArea.vue';
import { OrganizationTypeSelectorMixin, SportsSelectorMixin, CountriesSelectorMixin, LeaguesSelectorMixin } from '../../mixins/SelectorMixins';
import { FormRulesMixin } from '@/mixins';

@Component({
	components: { 
		FileUploadArea,
	},
})
export default class OrganizationCreateOrgInfo extends Mixins(BAIconsMixin, VuetifyMixin, CountriesSelectorMixin, OrganizationTypeSelectorMixin, SportsSelectorMixin, FormRulesMixin, LeaguesSelectorMixin){
	@Prop() value = {
		valid: false,
		name: "",
		type: "",
		country: "",
		city: "",
		sport: SportName.Soccer,
		league: "",
		logoUrl: null,
		orgUrl: "",
		bio: "",
	};

	input(): void{
		this.$emit('input', this.value);
	}

	$refs:{
		form: HTMLFormElement;
	}

	async submit($event: Event): Promise<void> {
		$event.preventDefault();
		this.$refs.form.validate();
		if(this.value.valid === false) return;
		this.$emit('submit', this.value);
	}
}
